import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { WelcomePopUp } from "../../models/template";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StyleService, TemplateService } from "../../services";
import { Router } from "@angular/router";

@Component({
    selector: 'app-pop-up',
    templateUrl: './pop-up.component.html',
    styleUrls: ['./pop-up.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PopUpComponent {
    public welcomePopUp: WelcomePopUp;

    constructor(
        private readonly router: Router,
        public readonly styleService: StyleService,
        private readonly matDialogRed: MatDialogRef<any>,
        private readonly templateService: TemplateService,
        @Inject(MAT_DIALOG_DATA) private data: WelcomePopUp
    ) {
        this.welcomePopUp = data;
    }

    goToProfile() {
        const profilePageIndex = this.templateService.templateData.template.pageLinks.findIndex((page) => page.templateSettings.find((p) => p.sectionTitle === "Profile"));;

        if (profilePageIndex >= 0) {
            this.router.navigate([`/template/${profilePageIndex}`], { queryParams: { 
                goToProfile: true
             } });
            this.matDialogRed.close();
        }
    }

    public closePopUp(): void {
        this.matDialogRed.close();
    }

    public formatErrorMessage(message: string, errorsList: string[]) {
        let errList = '';

        for (let i = 0; i < errorsList.length; i++) {
            errList += `<li>${errorsList[i]}</li>`;
        }

        let errMsg = `<ul>${errList}</ul>`;
        return message.replace('{{ errors }}', errMsg);
    }
}